import React from "react";
var __jsx = React.createElement;
import Para from '../../atoms/Para';
import Skeleton from '../../atoms/Skeleton';
function Headline(_ref) {
  var _yextInfo$entities;
  var isLoading = _ref.isLoading,
    id = _ref.id,
    className = _ref.className,
    yextInfo = _ref.yextInfo,
    fieldId = _ref.fieldId,
    skeletonData = _ref.skeletonData;
  if (isLoading) {
    return __jsx(Skeleton, {
      className: className,
      width: skeletonData.width,
      type: skeletonData.type
    });
  }
  var fieldValue = (yextInfo === null || yextInfo === void 0 ? void 0 : yextInfo[fieldId]) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities = yextInfo.entities) === null || _yextInfo$entities === void 0 ? void 0 : _yextInfo$entities[0][fieldId]);
  if (fieldValue) {
    return __jsx(Para, {
      id: id,
      className: className,
      removeDefaultStyles: true
    }, fieldValue);
  }
}
export default Headline;